const UserAvatarTexts = {
  'components.userAvatar.userAvatarModal.title': 'User details',
  /* Buttons */
  'components.userAvatar.sendMessageButton': 'Send message',
};

export default {
  ...UserAvatarTexts,
};
